import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'lib-network-model-no-data',
  templateUrl: './network-model-no-data.component.html',
  styleUrls: ['./network-model-no-data.component.scss'],
  standalone: false
})
export class NetworkModelNoDataComponent {
  @Input() titleText!: string;
  @Input() buttonText!: string;
  @Input() type!: string;

  @Output() equipmentOutput = new EventEmitter<void>();
  @Output() substationOutput = new EventEmitter<void>(); 

  constructor(public permissionsService: PermissionsService){}

  onAction() {
    if (this.type == 'Equipment') {
      this.equipmentOutput.emit();
    } else if (this.type == 'Substation') {
      this.substationOutput.emit();
    }
  }
}
